<template>
  <el-alert
    v-if="!originalBoss"
    title="当前团队未设置BOSS,请先设置BOSS"
    type="info"
    show-icon
    :closable="false"
  ></el-alert>

  <div v-else class="transfer-boss">
    <el-alert title="转让团队BOSS，需要验证当前BOSS的身份" type="info" show-icon :closable="false" center></el-alert>
    <div class="form-item">
      <span>{{selectPeopleConfig.label}}</span>
      <select-people
        @byEmployee="setEmployees"
        :onlySelectEmployee="true"
        :defaultVal="defaultEmployees"
        :disabledSelect="selectPeopleConfig.disabled"
        defaultShowText="请选择新的BOSS"
        class="select-people"
        onlySelectOneEmployee
      />
      <el-alert title="您还未选择人员！" type="error" show-icon :closable="false" v-show="errorStatus"></el-alert>
    </div>

    <div class="form-item">
      <span>手机号</span>
      <div class="phone">
        <el-input disabled v-model="phoneNumber"></el-input>
        <verification-code
          :phoneNum="phoneNumber"
          :deviceID="phoneNumber"
          :verification="verifyPhone"
          businessType="transferBoss"
          ref="code"
        />
      </div>
    </div>

    <div class="form-item">
      <span>验证码</span>
      <el-input placeholder="请填写验证码" v-model="code"></el-input>
    </div>

    <el-button @click="confirmSubmit">{{selectPeopleConfig.actionLabel}}</el-button>
  </div>
</template>

<script>
import VerificationCode from "@/components/VerificationCode/VerificationCode";

export default {
  components: {
    VerificationCode
  },
  data() {
    return {
      originalBoss: null,
      newBoss: null,
      phoneNumber: "",
      errorStatus: false,
      code: "",
      defaultEmployees: [],
      validation: false
    };
  },
  computed: {
    selectPeopleConfig() {
      if (this.validation) {
        return {
          label: "选择新的BOSS",
          disabled: false,
          actionLabel: "确定",
          action: this.transferBoss
        };
      } else {
        return {
          label: "当前BOSS",
          disabled: true,
          actionLabel: "下一步",
          action: this.verifyBoss
        };
      }
    }
  },
  created() {
    this.getBoss();
  },
  methods: {
    getBoss() {
      this.$api.getBoss().then(data => {
        this.originalBoss = data;
        this.defaultEmployees.push({
          type: 1,
          id: data.id,
          name: data.employeeName
        });
      });
    },

    async verifyCode() {
      if (!this.code) {
        this.$message.error("验证码不能为空");
        return false;
      }

      let status = await this.$api
        .validateCode({
          code: this.code,
          phoneNum: this.phoneNumber,
          deviceID: this.phoneNumber,
          type: "mobile"
        })
        .then(() => true)
        .catch(() => false);

      return status;
    },

    verifyBoss() {
      this.validation = true;
      this.defaultEmployees = [];
      this.code = "";
      this.$refs.code.send = false;
    },

    async transferBoss() {
      if (this.errorStatus) {
        this.$message.error("您还未选择人员，请先选择！");
        return;
      }
      if (this.newBoss.id === this.originalBoss.id) {
        this.$message.error("您选择了原来的BOSS，请重新选择！");
        return;
      }

      await this.$api.checkNormalEmployee(this.phoneNumber);

      await this.$api.transferBoss(this.phoneNumber);

      this.$message.success("转让成功！");
    },

    verifyPhone() {
      if (!this.phoneNumber) {
        this.errorStatus = true;
        return false;
      }
      return true;
    },

    async confirmSubmit() {
      let status = await this.verifyCode();
      if (!status) {
        return;
      }
      this.selectPeopleConfig.action();
    },

    async setEmployees(val) {
      if (!(val && val.length)) {
        this.phoneNumber = "";
        return;
      }

      if (this.errorStatus) {
        this.errorStatus = false;
      }
      this.newBoss = await this.$api.getEmployee(val[0].id);
      this.phoneNumber = this.newBoss.employeePhoneNum;
    }
  }
};
</script>

<style scoped lang="scss">
.transfer-boss {
  width: 600px;

  .el-alert {
    margin: 5px 0 20px 0;
  }
}

.form-item {
  margin-bottom: 20px;

  &:nth-child(2) {
    .select-people {
      margin-left: 25px;
    }
  }

  span {
    font-size: 14px;
    font-weight: bold;
    color: #606266;
    margin-bottom: 10px;
    display: inline-block;
  }

  &:nth-child(3) {
    .phone {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .ivu-btn {
        padding: 8px 15px;
        margin-left: 50px;
      }
    }
  }
}
</style>